import { render, staticRenderFns } from "./l12runoff.vue?vue&type=template&id=13924d88&scoped=true&"
import script from "./l12runoff.vue?vue&type=script&lang=js&"
export * from "./l12runoff.vue?vue&type=script&lang=js&"
import style0 from "./l12runoff.vue?vue&type=style&index=0&id=13924d88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13924d88",
  null
  
)

export default component.exports